import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { Flex } from '../../../../App/Components'
import { PriceFont, TimeSpanFont } from '../../Typography'

import { IProps } from './IProps'

export const LargePrice: FunctionComponent<IProps> = ({
  packagePrice,
  packageDuration,
  fontColor,
}) => {
  const { t } = useTranslation()
  return (
    <Flex container justifyContent={'center'}>
      <PriceFont fontColor={fontColor}>{t(packagePrice)}</PriceFont>
      <TimeSpanFont fontColor={fontColor}>{t(packageDuration)}</TimeSpanFont>
    </Flex>
  )
}
